<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="studentDiligences"
      item-key="id"
      :server-items-length="studentCount"
      :options.sync="tableOptions"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
    >
      <!-- Học sinh -->
      <template #item.student="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <!-- Ngày sinh -->
      <template #item.dob="{ item }">
        {{ item.student.dob | ddmmyyyy }}
      </template>
      <!-- Lớp -->
      <template #item.class="{ item }">
        {{ item.student | _get('currentClass.title') }}
      </template>
      <!-- Số ngày nghỉ -->
      <template #item.absentNo="{ item }">
        {{ item.diligences.length }}
      </template>
      <!-- Có phép -->
      <template #item.valid="{ item }">
        {{ item.diligences.filter(d => d.type === 'valid').length }}
      </template>
      <!-- Không phép -->
      <template #item.invalid="{ item }">
        {{ item.diligences.filter(d => d.type === 'invalid').length }}
      </template>
      <!-- Thao tác -->
      <template #item.action="{ item }">
        <v-btn class="elevation-0" icon @click="openDiligenceDetailDialog(item.student, item.diligences)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <DiligenceDetailDialog
      :state="addDiligence"
      :student="selectedStudent"
      :diligences="selectedDiligences"
      @createdDiligence="searchStudentDiligences(studentSearchParams)"
      @updateDiligence="searchStudentDiligences(studentSearchParams)"
      @deletedDiligence="searchStudentDiligences(studentSearchParams)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import utils from '@/plugins/utils'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import DiligenceDetailDialog from './DiligenceDetailDialog.vue'

const defaultHeaders = [
  {
    text: 'Học sinh',
    value: 'student',
    align: 'left',
    sortable: true,
    show: true
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    align: 'left',
    sortable: true,
    show: true
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'center',
    sortable: false,
    show: true
  },
  {
    text: 'Số ngày nghỉ',
    value: 'absentNo',
    align: 'center',
    sortable: false,
    show: true
  },
  {
    text: 'Có phép',
    value: 'valid',
    align: 'center',
    sortable: false,
    show: true
  },
  {
    text: 'Không phép',
    value: 'invalid',
    align: 'center',
    sortable: false,
    show: true
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'center',
    sortable: false,
    show: true
  }
]
export default {
  data() {
    return {
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 5
      },
      selectedStudent: {},
      selectedDiligences: [],
      addDiligence: false,
      studentSearchParams: {},
      studentCount: 0,
      loading: false
    }
  },
  components: {
    CardStudentName,
    DiligenceDetailDialog
  },
  computed: {
    ...mapState('Diligence', ['studentDiligences']),
    ...mapGetters('auth', ['ownClassIds']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': this.tableOptions.itemsPerPage,
        'page-text': utils.paginationText(this.tableOptions, this.studentCount)
      }
      if (this.studentCount > 100) {
        footerOptions['items-per-page-options'] = [5, 10, 15]
      }
      return footerOptions
    }
  },
  methods: {
    ...mapActions('students', ['getStudentCount']),
    ...mapActions('Diligence', ['getStudentDiligences']),
    openDiligenceDetailDialog(student, diligences) {
      this.addDiligence = !this.addDiligence
      this.selectedStudent = student
      this.selectedDiligences = diligences
    },
    async searchStudentDiligences(filters) {
      this.loading = true
      // New filter
      if (filters) {
        this.tableOptions.page = 1
        const studentFilters = {}
        if (filters.student) {
          studentFilters.id = filters.student
        } else {
          if (filters.class) {
            studentFilters.currentClass = filters.class
          } else {
            if (filters.grade) {
              studentFilters.grade = filters.grade
            }
            if (this.ownClassIds) {
              studentFilters['currentClass_in'] = this.ownClassIds
            }
          }
        }
        this.getStudentCount(studentFilters)
          .then(response => {
            this.studentCount = response
          })
          .catch(error => {
            console.error(error)
            this.$alert.error('Không lấy được số lượng học sinh')
          })
        this.studentSearchParams = { ...studentFilters, ...this.pageSetting() }
      } else {
        this.studentSearchParams = { ...this.studentSearchParams, ...this.pageSetting() }
      }
      try {
        await this.getStudentDiligences(this.studentSearchParams)
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần')
        console.error(error)
      }
      this.loading = false
    },
    pageSetting() {
      return {
        _start: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
        _limit: this.tableOptions.itemsPerPage,
        _sort: 'nameToNumber:ASC'
      }
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.searchStudentDiligences()
        }
      },
      deep: true
    }
  }
}
</script>
